module.exports = __webpack_public_path__ + "img/icon2.8ccf7106.png";